import { useSelector } from "react-redux";
import { selectClients } from "app/redux/clientsSlice";
import { selectActiveEmployees } from "app/redux/employeesSlice";
import { selectBusinessServices } from "app/redux/businessServicesSlice";
import {selectProducts} from "../../../redux/productSlice";

export const useQuickCheckoutData = () => {
    const { clients } = useSelector(selectClients);
    const employees = useSelector(selectActiveEmployees);
    const businessServices = useSelector(selectBusinessServices);
    const { products, categories } = useSelector(selectProducts);
    const normalizedClients = clients.map((c) => ({
        id: c.id,
        name: c.name,
        email: c.email,
        phone: c.phone,
    }));

    const staff = employees.map((e) => ({
        id: e.id,
        name: e.name,
        services: e.services,
    }));

    const normalizedProducts = products.map((p: any) => ({
        id: p.id,
        title: p.title,
        description: p.description,
        priceCents: p.priceCents ?? 0,
        category:
            categories?.find((c: any) => c.id === p.categoryId)?.name || "General",
    }));

    return {
        clients: normalizedClients,
        staff,
        products: normalizedProducts,
    };
};